import { EH_NOVA_INSCRICAO, LIMPAR_EH_NOVA_INSCRICAO } from './actionTypes';

export const ehNovaInscricao = () => ({ type: EH_NOVA_INSCRICAO });

export const limparEhNovaInscricao = () => ({ type: LIMPAR_EH_NOVA_INSCRICAO });